import "./PersonalInformationMobile.css";

import profile from "../../../../../../assets/settings-profile.png";

const PersonalInformationMobile = ({ setActive }) => {
 return (
  <div className="settings-mobile-personalinformation">
   <div className="settings-mobile-personalinformation">
    <div className="profile">
     <div className="img-container">
      <img src={profile} alt="profile" />
     </div>
     <div className="name-container">
      <p className="title">Nsikan Etukudoh</p>
      <p onClick={() => setActive("editpersonalinformation")}>Go to profile</p>
     </div>
    </div>
    <div className="info-container">
     <div className="item">
      <p>Legal name</p>
      <p>Nsikan Etukudoh</p>
     </div>
     <div className="item">
      <p>Email address</p>
      <p>flekumxzy@gmail.com</p>
     </div>

     <div className="item">
      <p>Phone number</p>
      <p>+234 7035345753</p>
     </div>

     <div className="item">
      <p>Gender</p>
      <p>Not specified</p>
     </div>

     <div className="item">
      <p>Date of birth</p>
      <p>06/08/1997</p>
     </div>

     <div className="item">
      <p>Address</p>
      <p>Not specified</p>
     </div>

     <div className="item">
      <p>Government ID</p>
      <p>English</p>
     </div>
    </div>
   </div>
  </div>
 );
};

export default PersonalInformationMobile;
